<template>
  <button
    class="toggler"
    :class="{ 'toggler--active': value }"
    @click.prevent="$emit('input', ! value)"
    >
    <span class="toggler__inner"></span>
  </button>
</template>

<script>
  export default {
    props: {
      value: {
        type: Boolean,
        required: true,
      },
    },
  };
</script>

<style lang="scss">
  .toggler {
    padding: 0;
    width: 29px;
    height: 16px;
    transition: 300ms;
    align-items: center;
    border-radius: 100px;
    display: inline-flex;
    background-color: #c5c3dc;

    &--active {
      background-color: #3e388b;

      .toggler__inner {
        margin-left: 14px;
      }
    }

    &__inner {
      width: 14px;
      height: 14px;
      transition: 300ms;
      margin-right: auto;
      border-radius: 100px;
      background-color: #FFF;
    }
  }
</style>
